










































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { companyWebservice } from '@/webservices/company';
import type { CompanyData } from '@/models/companyData';

@Component({
    name: 'CloneDataModal',
})
export default class CloneDataModal extends Vue {
    private isCloning: boolean = false;
    private dataCloned: boolean = false;
    private withLessons: boolean = false;
    private withTags: boolean = false;
    private withPMPhases: boolean = false;
    private withPMLessons: boolean = false;

    @Prop() private company: CompanyData;

    private toggleCloneDataModal() {
        this.$emit('toggleCloneDataModal');
    }

    private cloneAllDataToCompany() {
        this.isCloning = true;
        companyWebservice
            .cloneAllDataToCompany(this.company, this.withLessons, this.withTags, this.withPMPhases, this.withPMLessons)
            .then((response) => {
                this.$buefy.toast.open({
                    duration: 5000,
                    message: this.$t('toastMessages.store.cloningSuccessful').toString(),
                    type: 'is-success',
                });
                this.dataCloned = true;
                this.isCloning = false;
            })
            .catch((error) => {
                this.$buefy.toast.open({
                    duration: 5000,
                    message: this.$t('toastMessages.error.cloningError').toString(),
                    type: 'is-danger',
                });
                this.isCloning = false;
                console.log(error);
            });
    }
}
